import React, {useState,useEffect} from 'react';
import {RouteComponentProps, Redirect, Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import {Inc,Owner} from './Inc';
import Ajax from './Ajax';
import MultiLines from './MultiLines';
import RowData from './RowData';
import RowTable from './RowTable';
import BottomButtons from './BottomButtons';
import StoreImg from './StoreImg';
import Loading from './Loading';
import Title from './Title';

interface Props {
    owner:Owner,
}

interface RCProps extends RouteComponentProps<{id:string}> {
	
}

//let isLoading:boolean = true;
//let newsId = 0;

const NewsDetail = (props:Props)=> {
    Ajax.setEditorId(props.owner.owner_id);

    const rcp:RCProps = useReactRouter();
    const classes = useStyles();
    const [states,setStates] = useState({
        news: Inc.defaultNews(),
        isLoading: true,
        newsId: 0,
        notFound: false,
    });
    const load = ()=>{
        if( !rcp.match.params.id ){
            return;
        }
        const newsId = parseInt(rcp.match.params.id);
        setStates({...states,isLoading:true});
        Ajax.send("news/get",{news_id:newsId},(res:any)=>{
            //console.log(res);
            //isLoading = false;
            if( res.ok ){
                setStates({news:Inc.convNews(res.news),newsId:newsId,isLoading:false,notFound:false});
            } else {
                setStates({...states,isLoading:false,notFound:true});
            }
        });
    }
    useEffect( ()=>{
        //if( rcp.match.params.id ){
            //newsId = parseInt(rcp.match.params.id);
            load();
        //}
    },[]);

    if( states.notFound ){
        return (
            <Redirect to="/"/>
        );
    }

    const toEdit = "/news/input/" + String(states.news.news_id);

    return (
		<div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <Title text="ニュース詳細" icon="portrait"/>
                        <div style={{marginBottom:"1em"}}>
                        このニュースの内容を修正したい場合は、「編集する」を押して下さい。<br/>
                        </div>

                        <Hidden mdUp implementation="js">
							<BottomButtons
								button1='編集する' link1={toEdit}
								button2='一覧にもどる' link2='/news'
							/>
                        </Hidden>

                        <Table>
                            <TableBody>
                                <RowTable name="タイトル" value={
                                    <React.Fragment>
                                    {states.news.news_name}
                                    </React.Fragment>
                                } widths={["8em",""]}/>
                                <RowTable name="本文" value={
                                    <MultiLines text={states.news.news_body}/>
                                } widths={["8em",""]}/>
                                <RowTable name="画像" value={
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                                    {states.news.photo_ids.map((img_id:number,index:number)=>{
                                        const key = "img"+index;
                                        return (
											<div key={key} style={{ flex: '0 0 auto', width: '100px', height: '75px', marginTop:'0.25em' }}>
                                            <StoreImg owner_id={props.owner.owner_id} img_id={img_id} thumb={true} className="imgProfile"/>
											</div>
                                        );
                                    })}
                                    </div>
                                } widths={["8em",""]}/>
                                <RowTable name="公開日" value={
                                    <React.Fragment>
                                    {states.news.news_date}
                                    </React.Fragment>
                                } widths={["8em",""]}/>
                                <RowTable name="終了日" value={
                                    <React.Fragment>
                                    {states.news.end_date}
                                    </React.Fragment>
                                } widths={["8em",""]}/>
                                <RowTable name="状態" value={
                                    <React.Fragment>
                                    {states.news.status_label}
                                    </React.Fragment>
                                } widths={["8em",""]}/>

                            </TableBody>
                        </Table>

                    </Paper>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
                        <RowData name="ニュースID" value={String(states.news.news_id)}/>
                        <RowData name="状態" value={states.news.status_label}/>
                        
                        <Hidden smDown implementation="js">
                            <Divider style={{margin:"1em 0"}}/>
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={12}>
                                    <Link to={toEdit}><Button variant="contained" color="primary" style={{width:"100%"}}>編集する</Button></Link>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Link to="/news"><Button variant="outlined" style={{width:"100%"}}>一覧にもどる</Button></Link>
                                </Grid>
                            </Grid>
                        </Hidden>
                    </Paper>
                </Grid>
            </Grid>
			<Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default NewsDetail;
